const React = require("react");
const Section = require("../Section/");

module.exports = ({documents: rawDocuments, additionalStyles}) => {
  const documents = rawDocuments.filter((el) => el);
  return (
    <Section
      subtitle="Supporting documents"
      items={documents.length
        ? documents.map((el) => ({title: el.doc_type, hideValue: true}))
        : [{title: 'Not Completed', hideValue: true}]
      }
      additionalStyles={additionalStyles}
      withBorder
    />
  )
}
